export const textRoutesDefinitions = {
  kfkV2: {
    path: 'home',
    name: 'kfkV2'
  },
  results: {
    path: 'results',
    name: 'questionResults'
  },
  bookScores: {
    path: 'book-scores',
    name: 'bookScores'
  },
  bookScoreByCourseCode: {
    path: 'book-scores/:courseCode',
    name: 'bookScoreByCourseCode'
  },
  homeInitFailed: {
    path: 'init-failed',
    name: 'homeInitFailed'
  }
};
